import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import { Alert } from '@mui/material'

import {
  COLOR_OPS_NOTES,
  OPERATIONS_NOTES_INFO,
} from 'components/reports/Metrics/constants/ExceptionMetrics'
import { useGetExceptionMetricsOperationsNotesQuery } from 'generated/graphql'

import { MetricCard } from '../components'
import { useExceptionMetricsQueryInput } from './useExceptionMetricsQueryInput'

export const OperationsNotesMetricCard = () => {
  const { hasValidRange, input } = useExceptionMetricsQueryInput()

  const { data, previousData, loading, error } = useGetExceptionMetricsOperationsNotesQuery({
    variables: { input },
    skip: !hasValidRange,
    notifyOnNetworkStatusChange: true,
    nextFetchPolicy: 'cache-and-network',
  })

  const series =
    data?.exceptionMetricsOperationsNotes ?? previousData?.exceptionMetricsOperationsNotes

  if (error) {
    return <Alert severity='error'>Failed to load operations notes metric. Please try again.</Alert>
  }

  return (
    <MetricCard
      title='Jobs with operations notes'
      countCaption='Jobs with notes'
      tooltipLabel='With notes'
      color={COLOR_OPS_NOTES}
      icon={<DescriptionOutlinedIcon fontSize='small' />}
      info={OPERATIONS_NOTES_INFO}
      series={series}
      loading={loading && !series}
    />
  )
}
